import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { URLConfig } from "../../configs/url-config";
import { NbToastrService } from "@nebular/theme";
 

@Injectable({
  providedIn: "root"
})
export class ApiService {
  constructor(private http: HttpClient,
    private toastrService: NbToastrService) { }

  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "multipart/form-data;"
    })
  };
  httpOptionsPost = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      'accept': 'application/json',
    })
  };
   

  post(url: any, dataModel: any) {
    return this.http.post(url, dataModel, this.httpOptionsPost);
  }

  getRequest<T>(url: string): Observable<T> {
    return this.http.get<T>(url);
  }

  getRequestWithParams<T>(url: string, params: any): Observable<T> {
    return this.http.get<T>(url, { params: params });
  }
  getItemDetail<T>(url: string, params: any): Observable<T> {
    return this.http.get<T>(url, { params: params });
  }

  postRequest<T>(url: string, dataModel: any): Observable<T> {
    return this.http.post<T>(url, dataModel);
  }

  postFormDataRequest(url: any, dataModel: any) {
    return this.http.post(url, dataModel, this.httpOptions);
  }

  patchRequest(url: any, dataModel: any) {
    return this.http.patch(url, dataModel);
  }

  putRequest(url: any, dataModel: any) {
    return this.http.put(url, dataModel);
  }

  putFormDataRequest(url: any, dataModel: any) {
    return this.http.put(url, dataModel, this.httpOptions);
  }

  async verifyToken(url: any, dataModel: any) {
    return await this.http.post(url, dataModel).toPromise();
  }

  deleteRequest(url: any,params: any) {
    return this.http.delete(url,{ params: params });
  }

  deleteRequestbody(url: any,params: any) {
    return this.http.delete(url,{body: params });
  }

  getValueLocalstorage(){
    return  JSON.parse(localStorage.getItem('user'))
  }

  saveAuthSession(userData: any): void {
    localStorage.setItem('token', userData?.token || '');
    localStorage.setItem('user', JSON.stringify(userData));
  }

  extractAuthData(payload: any): any {
    return payload?.data || payload || {};
  }

  isEmailVerified(userData: any): boolean {
    return Boolean(
      userData?.emailVerified ??
      userData?.isEmailVerified ??
      userData?.emailverified,
    );
  }

  getAuthEmail(userData: any, fallbackEmail = ''): string {
    return userData?.email || fallbackEmail || '';
  }

  
  success(param): void {
    this.toastrService.success(`${param}`, 'Success');
  }

  error(param): void {
    this.toastrService.danger(`${param}`, 'Error');
  }

  warning(param): void {
    this.toastrService.warning(`${param}`, 'Warning');
  }
  primary(param): void {
    this.toastrService.primary(`${param}`, 'Info');
  }

  info(param): void {
    this.toastrService.info(`${param}`, 'Info');
  }
}
